import IdleManager from "./idle-manager";

export interface RefreshManagerOptions {
  idleTimeout?: number;
  refreshFn: () => void | Promise<void>;
}

export class RefreshManager {
  private readonly idleManager: IdleManager;
  private readonly refreshFn: () => void | Promise<void>;

  constructor({ idleTimeout = 300000, refreshFn }: RefreshManagerOptions) {
    this.refreshFn = refreshFn;

    this.idleManager = new IdleManager({
      timeout: idleTimeout,
      onIdle: refreshFn,
    });
  }

  public start(): void {
    this.idleManager.start();
  }

  public stop(): void {
    this.idleManager.stop();
  }

  public manualRefresh(): void {
    this.refreshFn();
  }
}
